export default "__VITE_ASSET__C1p7X5xH__"